<script lang="ts" setup>
import { onMounted } from 'vue'
import { scrollToTop } from '~utils'
import { BehaviorScrollToTop } from '~/utils/interface'
import { OFFSET_SCROLL_TO_TOP } from '~/constants/account'
defineProps({
  title: {
    type: String,
    default: ''
  },
  linkBack: {
    type: String,
    default: ''
  }
})
onMounted(() => {
  scrollToTop(OFFSET_SCROLL_TO_TOP, BehaviorScrollToTop.INSTANT)
})
</script>
<template>
  <div class="sub-header d-flex align-items-center justify-content-center">
    <NuxtLink :to="linkBack" class="sub-header__icon-back d-flex align-items-center">
      <img src="~/assets/images/icons/ic-back-arrow.svg" alt="back arrow icon" width="24" height="24" />
    </NuxtLink>
    <div class="sub-header__name fw-700">{{ title }}</div>
  </div>
</template>
<style lang="scss" scoped>
@import '~scssAsset/mobile/layouts/header/sub-header.scss';
</style>
